import { STORY_SCENE_IDS } from "../../src/game/story";
import { NO_CONSUMABLES } from "../../src/game/Consumable";
import { GameState } from "../../src/game/GameState";
import { ALL_ARTICLE_IDS } from "../../src/game/manual";
import { STARTER_SKILLS } from "../../src/game/Skill";

export const layoutWithPlacedMachines: GameState = {
  minute: 0,
  day: 1,
  dayStartMinute: 0,
  money: 50,
  reputation: 2,
  consumables: NO_CONSUMABLES,
  clamps: 0,
  materialPiles: [
    {
      material: {
        id: "test-board-1",
        type: "board",
        species: "oak",
        width: 8,
        length: 96,
        thickness: 1,
        surface: "rough",
        jointedFaces: 1,
        jointedEdges: 2,
      },
      position: [4.5, 5.5],
      rotation: 0,
    },
  ],
  player: {
    name: "Player",
    position: [5, 6],
    direction: 0,
    inventory: [],
    away: null,
  },
  machines: [
    {
      machineTypeId: "workspace",
      position: [1, 2],
      rotation: 0,
      inputMaterials: [],
      processingMaterials: [],
      outputMaterials: [],
      tools: [],
      selectedOperationId: "rip",
      selectedParameters: { width: 8 },
      operationProgress: {
        status: "notStarted",
        phaseIndex: 0,
        minutesRemaining: 0,
      },
    },
    {
      machineTypeId: "miterSaw",
      position: [6, 3],
      rotation: 0,
      inputMaterials: [],
      processingMaterials: [],
      // A cut piece still sitting on the saw table — enough to make the
      // saw refuse to be lifted (direct-feed saws have no input bay)
      outputMaterials: [
        {
          id: "test-board-2",
          type: "board",
          species: "oak",
          width: 8,
          length: 96,
          thickness: 1,
          surface: "rough",
          jointedFaces: 1,
          jointedEdges: 2,
        },
      ],
      tools: [],
      selectedOperationId: "cutBoard",
      selectedParameters: { cutPosition: 4 },
      operationProgress: {
        status: "notStarted",
        phaseIndex: 0,
        minutesRemaining: 0,
      },
    },
    {
      machineTypeId: "worktable1x1",
      position: [9, 2],
      rotation: 0,
      inputMaterials: [],
      processingMaterials: [],
      outputMaterials: [],
      tools: [],
      selectedOperationId: "assemble",
      operationProgress: {
        status: "notStarted",
        phaseIndex: 0,
        minutesRemaining: 0,
      },
    },
  ],
  machineCrates: [],
  truck: { bed: [], crates: [] },
  storage: {
    upgrades: [],
  },
  shopInfo: {
    name: "One Car Garage",
    electricity: 120,
    size: [12, 16],
    materialDropoffPosition: [10, 13],
    entrancePosition: [6, 15],
  },
  progression: {
    tutorials: {
      opening: { step: 0, dismissed: true },
      firstNight: { step: 1, dismissed: false },
      dust: { step: 0, dismissed: false },
    },
    storeUnlocked: true,
    standUnlocked: true,
    // A staged shop is past the opening: every scene has played
    story: { scenesPlayed: [...STORY_SCENE_IDS] },
    lumberyardUnlocked: false,
    salesCompleted: 1,
    sweepingUnlocked: false,
    unlockedArticles: ALL_ARTICLE_IDS,
    readArticles: ALL_ARTICLE_IDS,
    xp: 0,
    skillPoints: 0,
    unlockedSkills: STARTER_SKILLS,
  },
  stand: [],
  standSetUp: true,
  customers: [],
  dust: {},
  shopVac: null,
  broomOwned: true,
  broomPosition: [0, 0],
  dustpan: {},
};
